
var products_on_page = $('.js-products-on-page');
var next_url = products_on_page.data('next-url');

var load_more_btn = $('.load-more-btn')
var load_more_spinner = $('.load-more__spinner')

if (next_url == "") {
  $(".load-more").addClass("is-hidden");
}

var load = true;
$(window).scroll(function () {
  var divTop = $('#scroll-to').offset().top,
    divHeight = $('#scroll-to').outerHeight(),
    wHeight = $(window).height(),
    windowScrTp = $(this).scrollTop();
  if ((windowScrTp > (divTop + divHeight - wHeight)) && (next_url != "")) {
    if (load) {
      load = false;
      $('body').find('.load-more-btn').trigger('click');
    }
  }
});


function initializeSwymForNewProducts() {
    // Pronađi template wishlist container iz postojećih proizvoda
    var templateWishlistContainer = document.querySelector('.product-grid .grid__item .swym-wishlist-collections-v2-container');
    
    if (!templateWishlistContainer) {
        console.log('Swym template not found');
        return;
    }
    
    // Pronađi nove proizvode koji nemaju wishlist
    var newProducts = document.querySelectorAll('.js-products-on-page .grid__item');
    var addedCount = 0;
    
    newProducts.forEach(function(product) {
        // Provjeri ima li već wishlist
        var existingWishlist = product.querySelector('.swym-wishlist-collections-v2-container');
        if (existingWishlist) return; // Preskači ako već ima
        
        // Pronađi product ID/URL
        var productLink = product.querySelector('a[href*="/products/"]');
        if (!productLink) return; // Preskači ako nema product link
        
        var productUrl = productLink.href;
        
        // Kloniraj cijeli wishlist container
        var clonedContainer = templateWishlistContainer.cloneNode(true);
        var innerWishlist = clonedContainer.querySelector('.swym-wishlist-collections-v2');
        
        if (innerWishlist) {
            // Ažuriraj product URL
            innerWishlist.setAttribute('data-product-id', productUrl);
            // Resetiraj positioning
            innerWishlist.style.transform = '';
            
            // Dodaj na proizvod
            var insertLocation = product.querySelector('.card__inner');
            if (insertLocation) {
                insertLocation.appendChild(clonedContainer);
                addedCount++;
            }
        }
    });
    
    console.log('Swym wishlist added to', addedCount, 'new products');
    
    // Aktiviraj Swym za nove elemente
    if (addedCount > 0 && window.SwymCallbacks) {
        window.SwymCallbacks.push(function(swat) {
            if (swat && swat.initializeActionButtons) {
                swat.initializeActionButtons();
            }
        });
    }
}

function loadMoreProducts() {
    $.ajax({
        url: next_url,
        type: 'GET',
        dataType: 'html',
        beforeSend: function () {
            load_more_btn.hide();
            load_more_spinner.show();
        }
    }).done(function (next_page) {
        load_more_spinner.hide();
        load_more_btn.show();
        var new_products = $(next_page).find('.js-products-on-page');
        var new_url = new_products.data('next-url');
        next_url = new_url;
        if (next_url == "") {
            $(".load-more").addClass("is-hidden");
        }
        products_on_page.append(new_products.html());
        
        // SPR reinicijalizacija
        // SPR.registerCallbacks();
        // SPR.initRatingHandler();
        // SPR.initDomEls();
        // SPR.loadProducts();
        // SPR.loadBadges();
        
        // Swym wishlist fix - jednostavno!
        initializeSwymForNewProducts();
        
        load = true;
    });
}